import React from 'react';
import classNames from 'classnames';
import { Button } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
import { AR } from '@one-thd/sui-icons';

const { string, bool, oneOf } = proptypes;

// Roomvo integration contract. Their third-party script scans the page for these exact
// class names to mount the "See This In My Room" visualizer, so they are behavioural
// hooks rather than styling and cannot be renamed or replaced with data- attributes.
// Kept out of the literal className strings so they read as API, not as CSS.
const ROOMVO_MOBILE_CONTAINER = 'roomvo-mobile-container--njvut';
const ROOMVO_CONTAINER = 'roomvo-container';
const ROOMVO_TRIGGER = 'roomvo-stimr';
const ROOMVO_CONTAINER_3D = 'roomvo-container_3d';
const ROOMVO_VIRTUAL_SAMPLE_TRIGGER = 'roomvo-product-display-button';

const BASE_TRIGGER_CLASSES = classNames(
  'sui-invisible sui-btn sui-px-4 sui-rounded-full sui-leading-normal sui-line-clamp-unset',
  'sui-normal-case sui-text-base sui-tracking-normal sui-z-10'
);

// Static strings so the sui- classes are extracted at build time.
// 'overlay' is the original look (pinned top-right of its positioned parent, AR icon after the text).
// 'pill' is the neutral white button; the consumer positions it via `className`.
const VARIANTS = {
  overlay: {
    classes: 'sui-absolute sui-top-2 sui-right-2 sui-bg-primary sui-shadow-xl',
    endIcon: AR,
    startIcon: null
  },
  pill: {
    classes: 'sui-bg-subtle sui-text-primary sui-shadow-md hover:sui-shadow-lg',
    endIcon: null,
    startIcon: AR
  }
};

const FloatingActionButton = ({
  itemId = '',
  text = 'See This In My Room',
  isMobile = false,
  className = '',
  buttonClassName = '',
  variant = 'overlay',
  virtualSample = false,
}) => {
  const config = VARIANTS[variant] || VARIANTS.overlay;
  return (
    <div className={classNames(isMobile && ROOMVO_MOBILE_CONTAINER, className)} data-component="RoomVo">
      <div className={`${virtualSample ? ROOMVO_CONTAINER_3D : ROOMVO_CONTAINER} sui-w-full sm:sui-w-auto`}>
        <Button
          className={classNames(
            ROOMVO_TRIGGER,
            virtualSample && ROOMVO_VIRTUAL_SAMPLE_TRIGGER,
            BASE_TRIGGER_CLASSES,
            config.classes,
            buttonClassName
          )}
          data-sku={itemId}
          type="button"
          startIcon={config.startIcon}
          endIcon={config.endIcon}
        >
          {text}
        </Button>
      </div>
    </div>
  );
};

FloatingActionButton.propTypes = {
  itemId: string,
  text: string,
  isMobile: bool,
  className: string,
  buttonClassName: string,
  variant: oneOf(['overlay', 'pill']),
  virtualSample: bool,
};

export default FloatingActionButton;
